import ButtonPseudo from '../button/button-pseudo';
import Popup from '../popup/popup';
import HintImage from './hint-image.png';

import cn from './notification-hint-popup.module.css';

export default function NotifiactionHintPopup({
  popupVisible,
  setPopupVisible,
}: {
  popupVisible: boolean;
  setPopupVisible: (data: boolean) => void;
}) {
  return (
    <Popup
      title="How to enable browser notifications"
      onCancelClick={() => setPopupVisible(false)}
      isVisible={popupVisible}
      popupClassName={cn.notificationHintPopup}
    >
      <div className={cn.notifiactionHintPopupContent}>
        <ol>
          <li>
            <div>
              Open <strong>Settings</strong> on your Mac.
            </div>
          </li>
          <li>
            <div>
              Find the <strong>Notifications</strong> section in the settings
              list.
            </div>
          </li>
          <li>
            <div>
              Open it and find your <strong>browser</strong> in the list of
              applications and navigate to it.
            </div>
          </li>
          <li>
            <div>Turn on notifications.</div>
          </li>
        </ol>
        <img src={HintImage} alt="Hint" className={cn.hintImage} />
        <div className={cn.closeWrapper}>
          <ButtonPseudo
            text="Close"
            onClick={() => setPopupVisible(false)}
            bold
          />
        </div>
      </div>
    </Popup>
  );
}
